import React from 'react';

import * as S from './ChatMessage.styles';

export interface ChatMessageProps {
  message: string;
}

export const ChatMessage: React.FC<ChatMessageProps> = ({ message }) => {
  return (
    <S.MessageContainer>
      <S.MessageBubble>{message}</S.MessageBubble>
    </S.MessageContainer>
  );
};

